
export const MONTHS:any=45;
export const NEED:any=316;
export const CAP:any=4;
export const dateYear=(m:any)=>new Date(2029,11+m,1).getFullYear();

/* p: Parameterwerte. Wirkungen: g Gruppen, b Haushalt Mrd/J, gr Wachstum, al Arbeitslosigkeit, sev Senkung Problemdruck, cut Bremsung des Anstiegs, pos Haltung auf den Achsen */
